<template>
    <div class="wizard-course-select">
        <div class="wizard-form--fieldset">
            <div class="wizard-form--field-row">
                <div class="wizard-form--field">
                    <ui-model-provider v-model="mainSelectValue" v-slot="{ value, updateValue }">
                        <ui-select
                                :disabled="false"
                                :required="true"
                                :value="value"
                                name="school"
                                id="id_school"
                                @change="updateValue">
                            <template slot="label">
                                <slot name="school-select-label"/>
                            </template>
                            <template slot="default">
                                <ui-option :value="''">
                                    {{ 'Bitte auswählen' }}
                                </ui-option>
                                <ui-option
                                        :value="school.id"
                                        v-for="school in schools"
                                        :key="school.id">
                                    {{ school.label }}
                                </ui-option>
                            </template>
                            <template slot="messages">
                                <form-field-messages :messages="{ error: fieldErrors['school'] }"/>
                            </template>
                        </ui-select>
                    </ui-model-provider>
                </div>
                <div class="wizard-form--field">
                    <ui-model-provider v-model="chainedSelectValue" v-slot="{ value, updateValue }">
                        <ui-select
                                name="service"
                                :disabled="!mainSelectValue"
                                :required="true"
                                :value="value"
                                id="id_service"
                                @change="updateValue">
                            <template slot="label">
                                <slot name="course-select-label"/>
                            </template>
                            <template slot="default">
                                <ui-option :value="''">
                                    {{ 'Bitte auswählen' }}
                                </ui-option>
                                <ui-option
                                        :value="course.id"
                                        v-for="course in courses"
                                        :key="course.course">
                                    {{ course.course }}
                                </ui-option>
                            </template>
                            <template slot="messages">
                                <form-field-messages :messages="{ error: fieldErrors['service'] }"/>
                            </template>
                        </ui-select>
                    </ui-model-provider>
                </div>
                <div class="wizard-form--field" v-if="hasDates">
                    <ui-select
                            :required="true"
                            name="date_0"
                            :value="dateValues[0] || ''"
                            id="id_date_0">
                        <template slot="label">
                            <slot name="date-select-label"/>
                        </template>
                        <template slot="messages">
                            <form-field-messages :messages="{ error: fieldErrors[`date_0`] }"/>
                        </template>
                        <ui-option :value="''">
                            {{ 'Bitte auswählen' }}
                        </ui-option>
                        <ui-option
                                :value="date.id"
                                v-for="date in dates"
                                :key="date.id">
                            {{ date.label }}
                        </ui-option>
                    </ui-select>
                </div>
            </div>
        </div>
        <div class="wizard-form--fieldset" v-if="hasModules">
            <div class="wizard-form--field-row">
                <div class="wizard-form--field">
                    <h3>Module</h3>
                </div>

                <div class="wizard-form--field" v-for="(module, moduleIdx) in modules" :key="module.name">
                    <ui-select
                            :required="true"
                            :name="`date_${moduleIdx}`"
                            :value="dateValues[moduleIdx] || ''"
                            :id="`id_date_${moduleIdx}`">
                        <template slot="label">
                            {{ module.name }}
                        </template>
                        <template slot="messages">
                            <form-field-messages :messages="{ error: fieldErrors[`date_${moduleIdx}`] }"/>
                        </template>
                        <ui-option :value="''">
                            {{ 'Bitte auswählen' }}
                        </ui-option>
                        <ui-option
                                :value="date.id"
                                v-for="date in module.dates"
                                :key="date.id">
                            {{ date.label }}
                        </ui-option>
                    </ui-select>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import UiModelProvider from '@dreipol/vue-ui/src/components/form/model-provider/model-provider';
    import UiSelect from '@dreipol/vue-ui/src/components/form/select/select';
    import UiOption from '@dreipol/vue-ui/src/components/form/option/option';
    import FormFieldMessages from '../form-field-messages/form-field-messages';

    export default {
        components: {
            FormFieldMessages,
            UiModelProvider,
            UiSelect,
            UiOption,
        },
        props: {
            courseData: {
                type: Object,
                required: true,
            },
            initialMainSelectValue: {
                type: String,
                default: '',
            },
            initialChainedSelectValue: {
                type: String,
                default: '',
            },
            initialDateValues: {
                type: Array,
                default() {
                    return [];
                },
            },
            fieldErrors: {
                type: Object,
                required: true,
            },
        },
        data() {
            return {
                mainSelectValue: this.initialMainSelectValue,
                chainedSelectValue: this.initialChainedSelectValue,
                dateValues: this.initialDateValues,
            };
        },
        computed: {
            schools() {
                return this.courseData.schools;
            },
            courses() {
                if (!this.mainSelectValue) {
                    return [];
                }

                return this.courseData.courses[this.mainSelectValue];
            },
            selectedCourse() {
                return this.courses.find(course => `${ course.id }` === this.chainedSelectValue);
            },
            dates() {
                if (!this.chainedSelectValue || !this.hasDates) {
                    return [];
                }

                return this.selectedCourse.dates;
            },
            modules() {
                if (!this.chainedSelectValue || !this.hasModules) {
                    return [];
                }

                return this.selectedCourse.modules;
            },
            hasDates() {
                return this.chainedSelectValue && this.selectedCourse.dates.length > 0;
            },
            hasModules() {
                return this.chainedSelectValue && this.selectedCourse.modules.length > 0;
            },
        },
        watch: {
            mainSelectValue() {
                this.chainedSelectValue = '';
            },
        },
    };
</script>
